import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import useZustandStore from '@src/helpers/zustand';

export interface KYCDataType {
  frameUrl: string;
  skipKycSession: boolean;
  sessionId: string;
}

const apiCall = ({
  apiKey,
  processKey,
}: {
  apiKey: string;
  processKey: string;
}) =>
  axiosInstance.post<KYCDataType>(
    "/api/kyc/partner/process",
    {
      partnerCode: "PU",
      token: processKey,
    },
    {
      headers: {
        "x-api-key": apiKey,
      },
    }
  );

export const usePartnerProcess = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { data: zData, setData } = useZustandStore();
  return useMutation(apiCall, {
    onSuccess() {
      navigate(`/${i18n.language}/source-of-income?redirected_from=identify-with-payunicard`);
    },
    onError({ response }) {
      setData({
        ...zData,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- we trust the api
        errorMessage: response.data.displayText || response.data.DisplayText,
      });
      navigate(`/${i18n.language}/error`);
    },
  });
};
